import { render, staticRenderFns } from "./OrderActionHold.vue?vue&type=template&id=033086bc&"
import script from "./OrderActionHold.vue?vue&type=script&lang=ts&"
export * from "./OrderActionHold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports